<template>
  <div class="site__body">
    <div class="faq__header">
      <h1 class="faq__header-title">Promotions</h1>
    </div>
    <div class="block-space block-space--layout--divider-thin"></div>
    <!-- <promotions-carousel></promotions-carousel> -->
    <featured :sliderPerPage='5'></featured>
    <div class="block-space block-space--layout--divider-thin"></div>
     <div class="container">
        <div class="document__content card">
           <h5 class="about__section-title">Featured Promotion: 20% off on Selected ACDelco Products until 12/31/22!</h5>
           <div class="document__content">
              <img style="float: left; margin-right: 10px;" src="https://res.cloudinary.com/dms-systems/image/upload/v1629128197/DMS-Auto/Manufacturer/ACDelco.jpg" width="125 px">
              <p>GM Partner Perks members can receive 20% off on selected ACDelco products using code ACD10.  Certain restrictions apply.  Offer cannot be used in combination with another promotion code. GM Partner Perks members can take advantage of these exclusive offers until 12/31/22. As a member, you can use your dashboard for a streamlined Trade Rebate claims process. Your qualifying purchases will be tracked, and rebate claims filed automatically, eliminating the need to mail or upload invoices. </p>
           </div>
        </div>
     </div>
     <div class="block-space block-space--layout--divider-20"></div>
     <div class="block-space block-space--layout--divider-20"></div>
     <div class="block-space block-space--layout--divider-20"></div>
  </div>

</template>

<script>
// import PromotionsCarousel from "./PromotionsCarousel";
import Featured from "../home/Featured.vue";

export default {
  name: "Promotions",
  components: {
      "featured": Featured
    // PromotionsCarousel,
  },
  created() {
    this.$ga.page({
        page: this.$route.fullPath,
        title: this.$route.name,
    });
  }
};
</script>


